export default __webpack_public_path__ + "static/media/cracha4.59f6f20d.png";